import { create } from 'zustand';

import { createInboxAccountFilterSlice } from './actions';
import { InboxAccountFilterStore } from './types';

export const useInboxAccountFilterStore = create<InboxAccountFilterStore>()(
  (set, get, store) => ({
    ...createInboxAccountFilterSlice(set, get, store),
  }),
);
